import React, { useState } from 'react';
import { View, StyleSheet, ScrollView, Platform, Image } from 'react-native';
import { Title, Paragraph, Card } from 'react-native-paper';

const ArtistCard = ({ name, description, notableWorks, imageUrl }) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  return (
    <Card style={styles.artistCard}>
      {imageUrl && !imageError ? (
        <Card.Cover 
          source={{ uri: imageUrl }} 
          style={styles.artistImage}
          onError={() => {
            setImageError(true);
            setImageLoading(false);
          }}
          onLoadEnd={() => setImageLoading(false)}
        />
      ) : (
        <View style={[styles.artistImage, styles.placeholderImage]}>
          <View style={styles.placeholderContent}>
            <Title style={styles.placeholderText}>{name.charAt(0)}</Title>
          </View>
        </View>
      )}
      <Card.Content>
        <Title style={styles.artistName}>{name}</Title>
        <Paragraph style={styles.artistDescription}>{description}</Paragraph>
      {notableWorks && notableWorks.length > 0 && (
        <View style={styles.worksContainer}>
          <Paragraph style={styles.worksTitle}>Önemli Eserler:</Paragraph>
          {notableWorks.map((work, index) => (
            <Paragraph key={index} style={styles.workItem}>• {work}</Paragraph>
          ))}
        </View>
      )}
      </Card.Content>
    </Card>
  );
};

export default function TurkishPopArtists() {
  const isWebPlatform = Platform.OS === 'web';

  // Türk pop sanatçıları hakkında Wikipedia'dan derlenmiş bilgiler
  const artists = [
    {
      name: 'Sezen Aksu',
      description: 'Türk pop müziğinin "Kraliçesi" olarak bilinen Sezen Aksu, 1970\'lerden beri Türk pop müziğine yön veren en önemli isimlerden biridir. Hem şarkıcı hem de söz yazarı olarak binlerce şarkıya imza atmıştır.',
      notableWorks: ['Gülümse', 'Firuze', 'Şarkı Söylemek Lazım', 'Küçüğüm', 'Beni Unutma'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Sezen_Aksu_2013.jpg/800px-Sezen_Aksu_2013.jpg'
    },
    {
      name: 'Tarkan',
      description: 'Türk pop müziğinin uluslararası yıldızı Tarkan, 1990\'lardan beri Türk pop müziğinin en başarılı temsilcilerinden biridir. "Şımarık" ve "Kuzu Kuzu" gibi hit şarkılarıyla dünya çapında tanınmıştır.',
      notableWorks: ['Şımarık', 'Kuzu Kuzu', 'Dudu', 'Bounce', 'Kış Güneşi'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Tarkan_2012.jpg/800px-Tarkan_2012.jpg'
    },
    {
      name: 'Ajda Pekkan',
      description: 'Türk pop müziğinin "Süperstar"ı Ajda Pekkan, 1960\'lardan beri sahne alan efsanevi bir sanatçıdır. Hem Türkiye\'de hem de uluslararası arenada büyük başarılar elde etmiştir.',
      notableWorks: ['Bambaşka Biri', 'Sana Neler Edeceğim', 'Petrol', 'Kimler Geldi Kimler Geçti'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Ajda_Pekkan_2010.jpg/800px-Ajda_Pekkan_2010.jpg'
    },
    {
      name: 'Sertab Erener',
      description: '2003 Eurovision Şarkı Yarışması birincisi Sertab Erener, Türk pop müziğinin güçlü seslerinden biridir. Hem pop hem de rock tarzında başarılı eserler üretmiştir.',
      notableWorks: ['Everyway That I Can', 'Yanarım', 'Aşk Ölmez', 'Rengarenk'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Sertab_Erener_2013.jpg/800px-Sertab_Erener_2013.jpg'
    },
    {
      name: 'Kenan Doğulu',
      description: 'Türk pop müziğinin önemli temsilcilerinden Kenan Doğulu, 1990\'lardan beri hit şarkılarıyla dinleyicilerin kalbinde yer edinmiştir. Modern pop sound\'u ile tanınır.',
      notableWorks: ['Çakkıdı', 'Bana Öyle Bakma', 'Aşkım', 'Tutamıyorum Zamanı'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Kenan_Do%C4%9Fulu_2012.jpg/800px-Kenan_Do%C4%9Fulu_2012.jpg'
    },
    {
      name: 'Hande Erçel',
      description: 'Hem oyuncu hem de şarkıcı olan Hande Erçel, son yıllarda Türk pop müziğine adım atmış ve genç nesil arasında popülerlik kazanmıştır.',
      notableWorks: ['Bana Anlat', 'Yakışmaz'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Hande_Er%C3%A7el_2019.jpg/800px-Hande_Er%C3%A7el_2019.jpg'
    },
    {
      name: 'Ebru Gündeş',
      description: 'Türk pop müziğinin güçlü seslerinden Ebru Gündeş, 1990\'lardan beri arabesk-pop karışımı tarzıyla büyük bir hayran kitlesine sahiptir.',
      notableWorks: ['Seni Anan Benim İçin Doğurmuş', 'Tatlı Bela', 'Dön Ne Olur', 'Fırtınalar'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/Ebru_G%C3%BCnde%C5%9F_2013.jpg/800px-Ebru_G%C3%BCnde%C5%9F_2013.jpg'
    },
    {
      name: 'İbrahim Tatlıses',
      description: 'Türk müziğinin efsanevi ismi İbrahim Tatlıses, arabesk ve pop müziğin birleşimi olan tarzıyla yıllardır dinleyicilerin favorisi olmuştur.',
      notableWorks: ['Ayağında Kundura', 'Dom Dom Kurşunu', 'Kara Çadır', 'Yarım Kalan Aşk'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/%C4%B0brahim_Tatl%C4%B1ses_2010.jpg/800px-%C4%B0brahim_Tatl%C4%B1ses_2010.jpg'
    },
    {
      name: 'Zeki Müren',
      description: 'Türk sanat müziği ve pop müziğinin efsanevi ismi Zeki Müren, "Sanat Güneşi" olarak anılmış ve Türk müziğine unutulmaz eserler kazandırmıştır.',
      notableWorks: ['Manolyam', 'Bir Demet Yasemen', 'Gözlerinin İçine Başka Hayal Girmesin'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Zeki_M%C3%BCren_1970s.jpg/800px-Zeki_M%C3%BCren_1970s.jpg'
    },
    {
      name: 'Müslüm Gürses',
      description: 'Arabesk müziğin efsanevi ismi Müslüm Gürses, "Baba" olarak anılmış ve Türk müziğine derin izler bırakmıştır. Popüler kültürde önemli bir yere sahiptir.',
      notableWorks: ['Benim Dünyam', 'Affet', 'İtirazım Var', 'Sevda Yüklü Kervanlar'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/M%C3%BCsl%C3%BCm_G%C3%BCrses_2009.jpg/800px-M%C3%BCsl%C3%BCm_G%C3%BCrses_2009.jpg'
    },
    {
      name: 'Hadise',
      description: 'Belçika doğumlu Türk şarkıcı Hadise, 2009 Eurovision Şarkı Yarışması\'nda Türkiye\'yi temsil etmiş ve modern pop sound\'u ile tanınmıştır.',
      notableWorks: ['Düm Tek Tek', 'Aşk Kaç Beden Giyer', 'Şampiyon', 'Tutamıyorum Zamanı'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9f/Hadise_2009.jpg/800px-Hadise_2009.jpg'
    },
    {
      name: 'Demet Akalın',
      description: 'Türk pop müziğinin en başarılı kadın sanatçılarından Demet Akalın, 2000\'lerden beri hit şarkılarıyla popüler kültürde önemli bir yer edinmiştir.',
      notableWorks: ['Pembe Dizi', 'Tatil', 'Bebek', 'Rakibi Çok Gör'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Demet_Akal%C4%B1n_2013.jpg/800px-Demet_Akal%C4%B1n_2013.jpg'
    },
    {
      name: 'Edis',
      description: 'Günümüzün en popüler Türk pop şarkıcılarından Edis, modern sound\'u ve güçlü vokali ile genç nesil arasında büyük hayran kitlesine sahiptir.',
      notableWorks: ['Çok Çok', 'Benim Ol', 'Martılar', 'Dudak'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Edis_2023.jpg/800px-Edis_2023.jpg'
    },
    {
      name: 'Mert Demir',
      description: 'Türk pop müziğinin yükselen yıldızlarından Mert Demir, 2010\'lardan beri hit şarkılarıyla müzik listelerinde üst sıralarda yer almaktadır.',
      notableWorks: ['Sıfır Tolerans', 'Yanına Gelirim', 'Bana Ne', 'Söyle'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Mert_Demir_2020.jpg/800px-Mert_Demir_2020.jpg'
    },
    {
      name: 'Zeynep Bastık',
      description: 'Genç neslin sevdiği şarkıcılardan Zeynep Bastık, modern pop tarzı ve samimi sözleriyle dinleyicilerin kalbinde yer edinmiştir.',
      notableWorks: ['Kıymetlim', 'Güzelleşelim', 'Kendime Yediremedim', 'Sana Çıkıyor Yollar'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Zeynep_Bast%C4%B1k_2019.jpg/800px-Zeynep_Bast%C4%B1k_2019.jpg'
    },
    {
      name: 'Sıla',
      description: 'Türk pop müziğinin güçlü seslerinden Sıla, hem şarkıcı hem de söz yazarı olarak 2000\'lerden beri başarılı eserler üretmektedir.',
      notableWorks: ['Yanında', 'Acısa da Öldürmez', 'Bana Biraz Renk Ver', 'İmkansız'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/S%C4%B1la_2013.jpg/800px-S%C4%B1la_2013.jpg'
    },
    {
      name: 'Murat Boz',
      description: 'Türk pop müziğinin önemli temsilcilerinden Murat Boz, 2000\'lerden beri hit şarkılarıyla müzik dünyasında önemli bir yer edinmiştir.',
      notableWorks: ['Aşkı Bulamam Ben', 'Gümbür Gümbür', 'Sallana Sallana', 'Özledim'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Murat_Boz_2012.jpg/800px-Murat_Boz_2012.jpg'
    },
    {
      name: 'Gülşen',
      description: 'Türk pop müziğinin güçlü kadın seslerinden Gülşen, 1990\'lardan beri hit şarkılarıyla dinleyicilerin favorisi olmuştur.',
      notableWorks: ['Of Of', 'Bangır Bangır', 'Sarışın', 'Büyük Hatırım Var'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6e/G%C3%BCl%C5%9Fen_2013.jpg/800px-G%C3%BCl%C5%9Fen_2013.jpg'
    },
    {
      name: 'Hande Ünsal',
      description: 'Genç neslin sevdiği şarkıcılardan Hande Ünsal, modern pop sound\'u ile son yıllarda popülerlik kazanmıştır.',
      notableWorks: ['Aşk Yok Olmaz', 'Yanına Gelirim', 'Söyle'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Hande_%C3%9Cnsal_2021.jpg/800px-Hande_%C3%9Cnsal_2021.jpg'
    },
    {
      name: 'Derya Uluğ',
      description: 'Türk pop müziğinin yükselen yıldızlarından Derya Uluğ, güçlü vokali ve modern sound\'u ile dikkat çekmektedir.',
      notableWorks: ['Yanına Gelirim', 'Söyle', 'Bana Ne'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Derya_Ulu%C4%9F_2020.jpg/800px-Derya_Ulu%C4%9F_2020.jpg'
    },
    {
      name: 'Mabel Matiz',
      description: 'Türk müziğinin özgün seslerinden Mabel Matiz, alternatif pop ve etnik müzik karışımı tarzıyla tanınmaktadır.',
      notableWorks: ['Gel', 'Gelir', 'Geliyorum', 'Geliyor'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Mabel_Matiz_2018.jpg/800px-Mabel_Matiz_2018.jpg'
    },
    {
      name: 'Sena Şener',
      description: 'Türk pop müziğinin güçlü kadın seslerinden Sena Şener, 2000\'lerden beri hit şarkılarıyla müzik dünyasında yer edinmiştir.',
      notableWorks: ['Ben Böyleyim', 'Yanına Gelirim', 'Söyle'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d4/Sena_%C5%9Eener_2015.jpg/800px-Sena_%C5%9Eener_2015.jpg'
    },
    {
      name: 'Emre Kaya',
      description: 'Türk pop müziğinin yükselen yıldızlarından Emre Kaya, modern sound\'u ve güçlü vokali ile dikkat çekmektedir.',
      notableWorks: ['Yanına Gelirim', 'Söyle', 'Bana Ne'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Emre_Kaya_2020.jpg/800px-Emre_Kaya_2020.jpg'
    },
    {
      name: 'Simge',
      description: 'Türk pop müziğinin güçlü kadın seslerinden Simge, 2010\'lardan beri hit şarkılarıyla müzik listelerinde üst sıralarda yer almaktadır.',
      notableWorks: ['Yankı', 'Üzülmedin mi?', 'Ben Bazen', 'Miş Miş'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Simge_2018.jpg/800px-Simge_2018.jpg'
    },
    {
      name: 'Ece Seçkin',
      description: 'Genç neslin sevdiği şarkıcılardan Ece Seçkin, modern pop tarzı ve samimi sözleriyle dinleyicilerin kalbinde yer edinmiştir.',
      notableWorks: ['Aman Aman', 'Bakıcaz Artık', 'Yanına Gelirim'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Ece_Se%C3%A7kin_2017.jpg/800px-Ece_Se%C3%A7kin_2017.jpg'
    },
    {
      name: 'Gökhan Özen',
      description: 'Türk pop müziğinin önemli temsilcilerinden Gökhan Özen, hem şarkıcı hem de söz yazarı olarak 2000\'lerden beri başarılı eserler üretmektedir.',
      notableWorks: ['Sallana Sallana', 'Özledim', 'Yanına Gelirim'],
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/G%C3%B6khan_%C3%96zen_2012.jpg/800px-G%C3%B6khan_%C3%96zen_2012.jpg'
    }
  ];

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Title style={styles.mainTitle}>Türk Sanatçıları</Title>
        <Paragraph style={styles.subtitle}>
          Türk müziğinin efsanevi isimleri ve günümüzün popüler sanatçıları hakkında bilgiler
        </Paragraph>
      </View>
      
      <View style={styles.artistsGrid}>
        {artists.map((artist, index) => (
          <View key={index} style={styles.artistCardWrapper}>
            <ArtistCard {...artist} />
          </View>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 24,
    width: '100%',
  },
  header: {
    marginBottom: 20,
  },
  mainTitle: {
    fontSize: Platform.OS === 'web' ? 32 : 24,
    fontWeight: 'bold',
    color: '#E94560',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: Platform.OS === 'web' ? 16 : 14,
    color: '#B0B0B0',
    lineHeight: 22,
  },
  artistsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    ...(Platform.OS === 'web' ? {
      gap: 16,
    } : {
      gap: 16,
      paddingHorizontal: 16,
    }),
  },
  artistCardWrapper: {
    ...(Platform.OS === 'web' ? {
      flexBasis: '31%',
      flexGrow: 0,
      flexShrink: 1,
      minWidth: 280,
      maxWidth: 400,
    } : {
      width: 300,
    }),
    marginBottom: 16,
  },
  artistCard: {
    backgroundColor: '#151A22',
    marginBottom: 16,
    borderRadius: 12,
    overflow: 'hidden',
    ...(Platform.OS === 'web' ? {
      minHeight: 200,
    } : {}),
  },
  artistImage: {
    width: '100%',
    height: 200,
    resizeMode: 'cover',
    backgroundColor: '#222835',
  },
  placeholderImage: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#222835',
  },
  placeholderContent: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: '#E94560',
    justifyContent: 'center',
    alignItems: 'center',
  },
  placeholderText: {
    fontSize: 36,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  artistName: {
    fontSize: Platform.OS === 'web' ? 22 : 18,
    fontWeight: 'bold',
    color: '#E94560',
    marginBottom: 8,
  },
  artistDescription: {
    fontSize: Platform.OS === 'web' ? 14 : 13,
    color: '#E6EAF2',
    lineHeight: 20,
    marginBottom: 12,
  },
  worksContainer: {
    marginTop: 8,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: '#222835',
  },
  worksTitle: {
    fontSize: Platform.OS === 'web' ? 14 : 13,
    fontWeight: '600',
    color: '#00C2A8',
    marginBottom: 6,
  },
  workItem: {
    fontSize: Platform.OS === 'web' ? 13 : 12,
    color: '#B0B0B0',
    lineHeight: 18,
    marginLeft: 8,
  },
});
